import { render } from "./StoreFilter.vue?vue&type=template&id=28856475&scoped=true"
import script from "./StoreFilter.vue?vue&type=script&lang=js"
export * from "./StoreFilter.vue?vue&type=script&lang=js"

import "./StoreFilter.vue?vue&type=style&index=0&id=28856475&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-28856475"

export default script